import React from 'react';
import { useParams } from 'react-router-dom';
import HTMLReport from '../Reporting/HTMLReport';

export default function RecipeReport() {
    const { businessUnit } = useParams();

    let url = `api/v1/recipe/recipereport?businessUnit=${businessUnit}`;
    let downloadName = `${businessUnit}-grade-list.html`;

    return (
        <HTMLReport url={url} downloadName={downloadName}></HTMLReport>
    )
}